window.PortfolioLoader = {
	init: function ($marker) {
		var loading = false;
		var canLoad = true;

		$(document).scroll(function () {
			let h = $(window).height();
			let pos = Math.abs($(document).scrollTop() - $marker.offset().top + $(window).height() );

			if (h > pos) {
				if (!loading && canLoad) {
					loading = true;

					var params = {
						_token: App.csrf,
						service_id: $marker.data('service_id'),
						tag_id: $marker.data('tag_id'),
						except: $('.vg-portfolio-page .vg-portfolio-item').map(function (i, e) {
							return $(this).data('id');
						}).toArray(),
					};

					$.get('/portfolio/load', params, function (data) {
						if (data.view) {
							$('.vg-portfolio-page .vg-portfolio-page-grid').append(data.view);
						} else {
							canLoad = false;
						}

						loading = false;
					});
				}
			}
		});
	}
};

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		let tagText = document.querySelector('#swiper-portfolio-filter .swiper-slide:not(.swiper-slide-duplicate) .tag-text.active');

		if(!tagText) {
			return
		}

		let id = tagText.closest('.swiper-slide').getAttribute('data-swiper-slide-index');
		let swiper = document.querySelector('#swiper-portfolio-filter').swiper;
		swiper.slideToLoop(id);
		swiper.autoplay.stop();
	}, 100);
});